import React, { type HTMLAttributes } from 'react';

import './style.scss';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import {
  Image,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';
import Truncate from 'react-truncate';
import classNames from 'classnames';
import type { NodeProject } from '../../../../types/uncinc_profile/nodes';

interface NodeProjectTeaserProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<NodeProject>;
  classes: string;
}

const NodeProjectTeaser: React.FC<NodeProjectTeaserProps> = ({ entity, classes }) => {
  const project = entity.toJS();
  const title = project.title[0].value;
  const imageStyles = project.field_media_item[0]?.styles;
  const src = [
    `${imageStyles?.ratio_1_1_xs || ''}`,
    `${imageStyles?.ratio_1_1_sm || ''}`,
    `${imageStyles?.ratio_1_1_md || ''}`,
    `${imageStyles?.ratio_1_1_xl || ''}`,
  ];

  return (
    <div className={classNames('NodeProjectTeaser', classes)}>
      <div className="NodeProjectTeaser__image">
        <Image
          src={src}
          alt={title}
        />
      </div>
      <div className="NodeProjectTeaser__content">
        <h3 className="NodeProjectTeaser__heading">
          <Truncate lines={2} ellipsis="...">
            <WysiwygField
              html={title}
            />
          </Truncate>
        </h3>
        <Truncate lines={3}>
          <WysiwygField
            html={project.body[0]?.summary}
            className="NodeProjectTeaser__body"
          />
        </Truncate>
      </div>
    </div>
  );
};

export default NodeProjectTeaser;
